"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const Select_1 = require("@material-ui/core/Select");
const classnames_1 = require("classnames");
const react_i18next_1 = require("react-i18next");
const RowsPerPageStyle_1 = require("./jss/RowsPerPageStyle");
const RowsPerPage = ({ pageOptions, size, onChange, ariaLabelPostFix, className, titleKey }) => {
    const classes = (0, RowsPerPageStyle_1.default)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const ariaLabelId = 'per-page-title';
    const newTiteKey = titleKey || 'history.perPageTitle';
    const updateActivePageOption = (event) => {
        onChange(0, event.target.value);
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, classnames_1.default)(classes.rowsPerPage, className) }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: classes.rowsPerPageTitle }, { children: t(newTiteKey) })), (0, jsx_runtime_1.jsx)("label", Object.assign({ style: {
                        position: 'absolute',
                        overflow: 'visible',
                        clip: 'rect(0 0 0 0)',
                        height: '1px; width: 1px',
                        margin: '-1px; padding: 0; border: 0'
                    }, htmlFor: ariaLabelId + ariaLabelPostFix }, { children: `${t(newTiteKey)} ${ariaLabelPostFix}` })), (0, jsx_runtime_1.jsx)(Select_1.default, Object.assign({ value: size, displayEmpty: true, onChange: updateActivePageOption, inputProps: {
                        name: 'page-title',
                        id: ariaLabelId + ariaLabelPostFix
                    }, renderValue: selected => (0, jsx_runtime_1.jsx)("span", Object.assign({ style: { paddingRight: '20px' } }, { children: selected })), id: ariaLabelId + ariaLabelPostFix + 'selectedId' }, { children: pageOptions === null || pageOptions === void 0 ? void 0 : pageOptions.map((numberOfPage, index) => ((0, jsx_runtime_1.jsx)(core_1.MenuItem, Object.assign({ value: numberOfPage }, { children: numberOfPage }), index))) }))] })) }));
};
exports.default = RowsPerPage;
//# sourceMappingURL=RowsPerPage.js.map